import { render, staticRenderFns } from "./prestockGoodsDetail.vue?vue&type=template&id=09c6b233&scoped=true&"
import script from "./prestockGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./prestockGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./prestockGoodsDetail.vue?vue&type=style&index=0&id=09c6b233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c6b233",
  null
  
)

export default component.exports